import { applySnapshot, Instance, SnapshotOut, types } from "mobx-state-tree"

export const CouponModel = types
  .model("Coupon")
  .props({
    coupon_id: types.optional(types.number, 0),
    coupon_name: types.maybeNull(types.string),
    description: types.maybeNull(types.string),
    start_at: types.maybeNull(types.string),
    end_at: types.maybeNull(types.string),
    img_full_url: types.maybeNull(types.string),
    couponStatus: types.maybeNull(types.string),
    tnc: types.maybeNull(types.string),
    website: types.maybeNull(types.string),
    use_at: types.maybeNull(types.string),
    start_date: types.maybeNull(types.string),
    voucher_catalog_id: types.maybeNull(types.number),
  })
  .actions((self) => ({
    update: (data) => {
      Object.assign(self, data)
    },
    useCoupon: () => {
      self.couponStatus = "used"
      self.use_at = new Date().toISOString()
    },
  }))
  .actions((self) => ({
    reset: () => {
      applySnapshot(self, {})
    },
  }))

export const CouponStoreModel = types
  .model("CouponStore")
  .props({
    coupons: types.array(CouponModel),
    isShowBadge: types.optional(types.boolean, false),
    newCouponNotifiedId: types.maybeNull(types.number),
  })
  .actions((self) => ({
    addCoupon: (couponData) => {
      const newCoupon = CouponModel.create(couponData)
      self.coupons.push(newCoupon)
    },
    removeCoupon: (couponId) => {
      const index = self.coupons.findIndex((coupon) => coupon.coupon_id === couponId)
      if (index !== -1) {
        self.coupons.splice(index, 1)
      }
    },
    useCoupon: (couponId) => {
      const coupon = self.coupons.find((c) => c.coupon_id === couponId)
      if (coupon) {
        coupon.useCoupon()
      }
    },
    clearCoupon: () => {
      applySnapshot(self, {})
    },
    setShowBadge(show: boolean) {
      self.isShowBadge = show
    },
    hideBadge() {
      self.isShowBadge = false
    },
    setNewCouponNotifiedId(id: number) {
      self.newCouponNotifiedId = id
    },
  }))

type CouponStoreType = Instance<typeof CouponStoreModel>
export interface CouponStore extends CouponStoreType {}

type CouponSnapshotType = SnapshotOut<typeof CouponModel>
export interface CouponSnapshot extends CouponSnapshotType {}
